export class AppStorage {
    static removeItem(key: string): void {
        window.localStorage.removeItem(key);
    }

    static getItem(key: string): string | null {
        return window.localStorage.getItem(key);
    }

    static saveItem = (key: string, data: string) => {
        window.localStorage.setItem(key, data);
        return true;
    };
}
